// removed by extract-text-webpack-plugin
module.exports = {"radio-card-default":"RadioButton__radio-card-default","radioCardDefault":"RadioButton__radio-card-default","radio-card-active":"RadioButton__radio-card-active","radioCardActive":"RadioButton__radio-card-active","error":"RadioButton__error","disabled":"RadioButton__disabled","radio":"RadioButton__radio","radio-skin":"RadioButton__radio-skin","radioSkin":"RadioButton__radio-skin"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/RadioGroup/components/RadioButton/RadioButton.scss
// module id = 1517
// module chunks = 8